/* eslint-disable react/no-multi-comp */
import React from 'react';
import { DocumentoContainerV2 } from '../../../components/v2';

const DocumentosTab = () => {
  return <DocumentoContainerV2 headerTitle="Documentos Auxiliares" modulo="NSIR" ativo />;
};

export default DocumentosTab;
